import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ListBoxSearch: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M8 5H13M13 9H8M9 13H8M17 9V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H9M5 5H5.01M5 9H5.01M5 13H5.01M16.2678 16.2678C16.7202 15.8154 17 15.1904 17 14.5C17 13.1193 15.8807 12 14.5 12C13.1193 12 12 13.1193 12 14.5C12 15.8807 13.1193 17 14.5 17C15.1904 17 15.8154 16.7202 16.2678 16.2678ZM16.2678 16.2678L18 18"
                {...pathProps}
            />
        </IconSVG>
    );
};
